module.exports = __webpack_public_path__ + "img/Market.8e762ef0.svg";